





// Function to create and display the popup with embedded AidaForm
// export function showPopup_duringQ() {
//     // Create popup elements
//     const popup = document.createElement('div');
//     popup.className = 'popup';

//     const popupContent = document.createElement('div');
//     popupContent.className = 'popup-content';

//     const closeButton = document.createElement('span');
//     closeButton.className = 'close';
//     closeButton.innerHTML = '&times;';

//     const message = document.createElement('p');
//     message.textContent = 'Please fill out the form below:';

//     // Create the AidaForm embed code
//     const formDiv = document.createElement('div');
//     formDiv.setAttribute('data-aidaform-app', 'form202405');
//     formDiv.setAttribute('data-url', 'https://cerdemo.aidaform.com/db-study2-during');
//     formDiv.setAttribute('data-width', '100%');
//     formDiv.setAttribute('data-height', '500px');
//     formDiv.setAttribute('data-do-resize', 'data-do-lazy');

//     // Append elements
//     popupContent.appendChild(closeButton);
//     popupContent.appendChild(message);
//     popupContent.appendChild(formDiv);
//     popup.appendChild(popupContent);
//     document.body.appendChild(popup);

//     // Show the popup
//     popup.style.display = 'block';

//     // Close the popup on click
//     closeButton.onclick = function() {
//         popup.style.display = 'none';
//         document.body.removeChild(popup); // Remove the popup from DOM
//     };

//     // Close the popup when clicking outside of it
//     window.onclick = function(event) {
//         if (event.target === popup) {
//             popup.style.display = 'none';
//             document.body.removeChild(popup); // Remove the popup from DOM
//         }
//     };

//     // Load the AidaForm script
//     const script = document.createElement('script');
//     script.innerHTML = `(function(){var r,d=document,gt=d.getElementById,cr=d.createElement,tg=d.getElementsByTagName,id="aidaform-app";if(!gt.call(d,id)){r=cr.call(d,"script");r.id=id;r.src="https://widget.aidaform.com/embed.js";(d.head || tg.call(d,"head")[0]).appendChild(r);}})()`;
//     document.body.appendChild(script);
// }





// Function to create and display the popup with embedded AidaForm
export function showPopup_duringQ() {
    // Create popup elements
    const popup = document.createElement('div');
    popup.className = 'popup';

    const popupContent = document.createElement('div');
    popupContent.className = 'popup-content';

    const closeButton = document.createElement('span');
    closeButton.className = 'close';
    closeButton.innerHTML = '&times;';

    const message = document.createElement('p');
    message.textContent = 'Please fill out the form below:';

    // Create an iframe for the embedded Google Form
    const iframe = document.createElement('iframe');
    iframe.src = 'https://docs.google.com/forms/d/e/1FAIpQLScrYLIpMvkLrNA7QslbGmj8dFQFCTmkPxfhXBAGSbS21gJVYQ/viewform?embedded=true'; // Google Form URL
    iframe.width = '100%';
    iframe.height = '1000px'; // Adjust the height as needed
    iframe.style.border = 'none'; // Optional: Remove iframe border
    iframe.style.overflowY = 'scroll'; // Optional: Add scrollbars

    // Append elements
    popupContent.appendChild(closeButton);
    popupContent.appendChild(message);
    popupContent.appendChild(iframe);
    popup.appendChild(popupContent);
    document.body.appendChild(popup);

    // Show the popup
    popup.style.display = 'block';

    // Close the popup on click
    closeButton.onclick = function() {
        popup.style.display = 'none';
        document.body.removeChild(popup); // Remove the popup from DOM
    };

    // Close the popup when clicking outside of it
    window.onclick = function(event) {
        if (event.target === popup) {
            popup.style.display = 'none';
            document.body.removeChild(popup); // Remove the popup from DOM
        }
    };
}

export function showPopup_pre() {
    // Create popup elements
    const popup = document.createElement('div');
    popup.className = 'popup';

    const popupContent = document.createElement('div');
    popupContent.className = 'popup-content';

    const closeButton = document.createElement('span');
    closeButton.className = 'close';
    closeButton.innerHTML = '&times;';

    const message = document.createElement('p');
    message.textContent = 'Please fill out the form below:';

    // Create an iframe for the embedded Google Form
    const iframe = document.createElement('iframe');
    iframe.src = 'https://docs.google.com/forms/d/e/1FAIpQLSf7w9AtVeV7Aes_Qo0WKII1g6dlyM2zHXUMHMFE6XaKOKF3Fg/viewform?embedded=true'; // Google Form URL
    iframe.width = '100%';
    iframe.height = '1000px'; // Adjust the height as needed
    iframe.style.border = 'none'; // Optional: Remove iframe border

    // Append elements
    popupContent.appendChild(closeButton);
    popupContent.appendChild(message);
    popupContent.appendChild(iframe);
    popup.appendChild(popupContent);
    document.body.appendChild(popup);

    // Show the popup
    popup.style.display = 'block';

    // Close the popup on click
    closeButton.onclick = function() {
        popup.style.display = 'none';
        document.body.removeChild(popup); // Remove the popup from DOM
    };

    // Close the popup when clicking outside of it
    window.onclick = function(event) {
        if (event.target === popup) {
            popup.style.display = 'none';
            document.body.removeChild(popup); // Remove the popup from DOM
        }
    };
}




export function showPopup_post() {
    // Create popup elements
    const popup = document.createElement('div');
    popup.className = 'popup';

    const popupContent = document.createElement('div');
    popupContent.className = 'popup-content';

    const closeButton = document.createElement('span');
    closeButton.className = 'close';
    closeButton.innerHTML = '&times;';

    const message = document.createElement('p');
    message.textContent = 'Please fill out the form below:';

    // Create an iframe for the embedded Google Form
    const iframe = document.createElement('iframe');
    iframe.src = 'https://docs.google.com/forms/d/e/1FAIpQLSdXhuoSfRprdpQYhCKxxm5RFC2lOzS7K1KfodAkxJkRZwkJsA/viewform?embedded=true'; // Google Form URL
    iframe.width = '100%';
    iframe.height = '1000px'; // Adjust the height as needed
    iframe.style.border = 'none'; // Optional: Remove iframe border

    // Append elements
    popupContent.appendChild(closeButton);
    popupContent.appendChild(message);
    popupContent.appendChild(iframe);
    popup.appendChild(popupContent);
    document.body.appendChild(popup);

    // Show the popup
    popup.style.display = 'block';

    // Close the popup on click
    closeButton.onclick = function() {
        popup.style.display = 'none';
        document.body.removeChild(popup); // Remove the popup from DOM
    };

    // Close the popup when clicking outside of it
    window.onclick = function(event) {
        if (event.target === popup) {
            popup.style.display = 'none';
            document.body.removeChild(popup); // Remove the popup from DOM
        }
    };
}



export function showPopupQ1b(linkUrl) {
    // Create popup elements
    const popup = document.createElement('div');
    popup.className = 'popup';

    const popupContent = document.createElement('div');
    popupContent.className = 'popup-content';

    const closeButton = document.createElement('span');
    closeButton.className = 'close';
    closeButton.innerHTML = '&times;';

    const message = document.createElement('p');
    message.textContent = 'This is a custom popup message.';
    const link = document.createElement('p');
    link.innerHTML = `Click <a href="${linkUrl}" target="_blank">Please answer the questionnaire before proceeding to the next session.</a> for more information.`;

    // Append elements
    popupContent.appendChild(closeButton);
    popupContent.appendChild(message);
    popupContent.appendChild(link);
    popup.appendChild(popupContent);
    document.body.appendChild(popup);

    // Show the popup
    popup.style.display = 'block';

    // Close the popup on click
    closeButton.onclick = function() {
        popup.style.display = 'none';
        document.body.removeChild(popup); // Remove the popup from DOM
    };

    // Close the popup when clicking outside of it
    window.onclick = function(event) {
        if (event.target === popup) {
            popup.style.display = 'none';
            document.body.removeChild(popup); // Remove the popup from DOM
        }
    };
}


// // Function to create and display the popup with a dynamic link
// function showPopup(linkUrl) {
//     // Create popup element with a custom form
//     const popup = document.createElement('div');
//     popup.className = 'popup';

//     const popupContent = document.createElement('div');
//     popupContent.className = 'popup-content';

//     const closeButton = document.createElement('span');
//     closeButton.className = 'close';
//     closeButton.innerHTML = '&times;';

//     const message = document.createElement('p');
//     message.textContent = 'Please fill out the form below:';

//     // Create the form
//     const form = document.createElement('form');
//     form.innerHTML = `
//         <label for="name">Name:</label>
//         <input type="text" id="name" name="name" required>
//         <br><br>
//         <label for="email">Email:</label>
//         <input type="email" id="email" name="email" required>
//         <br><br>
//         <input type="submit" value="Submit">
//     `;

//     // Append elements
//     popupContent.appendChild(closeButton);
//     popupContent.appendChild(message);
//     popupContent.appendChild(form);
//     popup.appendChild(popupContent);
//     document.body.appendChild(popup);

//     // Show the popup
//     popup.style.display = 'block';

//     // Close the popup on click
//     closeButton.onclick = function() {
//         popup.style.display = 'none';
//         document.body.removeChild(popup); // Remove the popup from DOM
//     };

//     // Close the popup when clicking outside of it
//     window.onclick = function(event) {
//         if (event.target === popup) {
//             popup.style.display = 'none';
//             document.body.removeChild(popup); // Remove the popup from DOM
//         }
//     };

//     // Handle form submission
//     form.onsubmit = function(event) {
//         event.preventDefault(); // Prevent the default form submission
//         const name = document.getElementById('name').value;
//         const email = document.getElementById('email').value;
//         console.log(`Name: ${name}, Email: ${email}`); // Process the form data as needed
//         popup.style.display = 'none'; // Optionally close the popup after submission
//         document.body.removeChild(popup); // Remove the popup from DOM
//     };
// }